import { configureStore } from "@reduxjs/toolkit";
// Common Module APIs (Auth)
import LOGIN from "../../modules/common/api/Auth/Login";
import LOGIN_OTP from "../../modules/common/api/Auth/Login/otp";

// Admin Module APIs
import DOWNLOAD_SAMPLE_STUDENT from "../../modules/admin/api/Sample/Student/index";
import UPLOAD_BULK_STUDENT from "../../modules/admin/api/Upload/Student/index";
import GET_STUDENT_LIST from "../../modules/admin/api/Data/Student/index";
import GET_ORGANISATION from "../../modules/admin/api/Organisation/index";
import APPOINTMENTS from "../../modules/admin/api/Appointments/index";
import APPOINTMENT_DETAIL from "../../modules/admin/api/Appointments/AppointmentDetail";
import GET_SUMMARY from "../../modules/admin/api/Dashboard/SummarySlice";
import GET_TOP_PRACTITIONER from "../../modules/admin/api/Dashboard/TopPractitionerSlice";
import GET_COUNSELLOR_LIST from "../../modules/admin/api/Data/Counsellor/index";
import GET_WELLNESS from "../../modules/admin/api/Wellness/WellnessSlice";
import PRACTITIONERS from "../../modules/admin/api/Practitioner/index";
import PRACTITIONER_DETAIL from "../../modules/admin/api/Practitioner/PractitionerDetail";
import ADD_PRACTITIONER from "../../modules/admin/api/Practitioner/AddPractitionerSlice";
import ADD_REMOVE_FAVOURITE from "../../modules/admin/api/Favourite/AddRemoveFavourite";

// Member Module APIs
import MEMBER_PROFILE from "../../modules/member/api/MemberProfile";
import COUNSELOR_LIST from "../../modules/member/api/CounselorList";
import MEMBER_ADD_REMOVE_FAVOURITE from "../../modules/member/api/AddRemoveFavourite";
import MEMBER_APPOINTMENTS from "../../modules/member/api/Appointments";
import ORGANIZATION_ATTRIBUTES from "../../modules/member/api/OrganizationAttributes";
import UPLOAD_FILE from "../../modules/admin/api/Upload/Image";

// Redux slices and actions (keep existing paths for now)
import { downloadMemberSampleReducer } from "../slice/Sample/Member";
import { uploadBulkMemberReducer } from "../slice/BulkUpload/Member";
import { getAttributesReducer, createAttributesReducer, updateAttributesReducer, deleteAttributesReducer } from "../slice/Attributes";
import { createMemberReducer } from "../slice/Member";
import createPractitionerReducer from "../slice/Practitioner";
import clientMemberReducer from "../slice/Client-Member";
import orgKycUsersReducer from "../slice/Kyc-Users";
import {
  getDeliveryTrendReducer,
  getQuickStatsReducer,
  getRiskStatusReducer,
} from "../slice/Stats";


export const store = configureStore({
  reducer: {
    login: LOGIN,
    loginOtp: LOGIN_OTP,
    downloadSampleStudent: DOWNLOAD_SAMPLE_STUDENT,
    uploadBulkStudent: UPLOAD_BULK_STUDENT,
    getStudentLists: GET_STUDENT_LIST,
    getOrgData: GET_ORGANISATION,
    appointments: APPOINTMENTS,
    appointmentDetail: APPOINTMENT_DETAIL,
    DOWNLOAD_MEMBER_SAMPLE_FILE: downloadMemberSampleReducer,
    UPLOAD_BULK_MEMBER: uploadBulkMemberReducer,
    GET_ATTRIBUTES: getAttributesReducer,
    CREATE_ATTRIBUTES: createAttributesReducer,
    UPDATE_ATTRIBUTES: updateAttributesReducer,
    DELETE_ATTRIBUTES: deleteAttributesReducer,
    CREATE_MEMBER: createMemberReducer,
    CREATE_PRACTITIONER: createPractitionerReducer,
    CLIENT_MEMBER: clientMemberReducer,
    ORG_KYC_USERS: orgKycUsersReducer,
    GET_DELIVERY_TREND: getDeliveryTrendReducer,
    GET_RISK_STATUS: getRiskStatusReducer,
    GET_SUMMARY: GET_SUMMARY,
    GET_TOP_PRACTITIONER: GET_TOP_PRACTITIONER,
    GET_COUNSELLOR_LIST: GET_COUNSELLOR_LIST,
    GET_WELLNESS: GET_WELLNESS,
    practitioners: PRACTITIONERS,
    practitionerDetail: PRACTITIONER_DETAIL,
    addPractitioner: ADD_PRACTITIONER,
    addRemoveFavourite: ADD_REMOVE_FAVOURITE,
    memberProfile: MEMBER_PROFILE,
    counselorList: COUNSELOR_LIST,
    memberAddRemoveFavourite: MEMBER_ADD_REMOVE_FAVOURITE,
    memberAppointments: MEMBER_APPOINTMENTS,
    organizationAttributes: ORGANIZATION_ATTRIBUTES,
    uploadFile: UPLOAD_FILE
  },
});
